export const cookieNames = {
  bevnet_token: 'bevnet_auth_token',
  access_token: 'access_token',
  refresh_token: 'refresh_token',
  tempDataId: 'tempDataSubscribe',

  tempJob: 'tempJob',
  tempPrepaidData: 'tempPrepaidData',
  tempRegisterData: 'tempRegisterData',
  tempReactivateJob: 'tempReactivateJob',

  invoice_token: 'invoice_token',

  // Shared last-touch UTM attribution cookie. Written+read by BOTH cpgjobs
  // (www.cpgjobs.com) and the react/jobs SPA (app.cpgjobs.com); in prod it is
  // scoped to `.cpgjobs.com` so both subdomains share it.
  utmParams: 'cpg_utm'
};
